var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 57,
    viewBox: "0 0 105 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 55.0011C2 55.0011 5.70674 43.6026 11.2156 38.8812C13.318 37.0793 15.0754 36.7003 16.4399 37.8707C17.459 38.7448 18.8032 42.6721 18.8032 42.6721C18.8032 42.6721 22.7407 30.8497 25.781 30.8497C28.8214 30.8497 28.8949 42.9395 31.0597 42.9395C33.2245 42.9395 32.5879 30.8497 34.5912 30.8497C36.5945 30.8497 38.4361 34.0352 41.5 36C44.5639 37.9648 48.1628 34.5 50 34.5C51.8372 34.5 57 27 57 27C57 27 61.9117 22.1635 63.5 21.5C65.0883 20.8365 76.988 9.00016 76.988 9.00016C76.988 9.00016 83.3171 13.9698 84 14C86.1411 14.0947 89.6144 14.5002 91 14.5002C92.8275 14.5002 92.7749 12.8322 96 11.5002C97.7157 10.7915 103 1 103 1L104 14.5002V39.5V54C104 54 104.677 59.2144 101.357 55.0011",
    fill: "url(#paint0_linear_1989_23534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 53.1723C2 53.1723 5.66065 42.7045 11.1795 38.0023C16.6983 33.3 18.8827 41.916 18.8827 41.916C18.8827 41.916 22.8173 30.1555 25.8631 30.1555C28.909 30.1555 28.9433 41.916 31.112 41.916C33.2807 41.916 32.5555 30.1555 34.5624 30.1555C36.5693 30.1555 38.4306 33.5431 41.5 35.5C44.5694 37.4569 46.1116 35.4947 50 33.5C54.7437 31.0665 55.6897 30.1945 58.5 25.5C61.1823 21.0192 64.0193 20.4007 65.5 19C66.9807 17.5993 69.039 14.5 71 14.5C72.5616 14.5 77.3159 9.96993 78 10C80.145 10.0943 81.5335 16.1973 85.5 13.5C87.6663 12.0269 88.2691 15.8266 91.5 14.5C94.7309 13.1734 96.9925 11.8437 99.5 9C101.582 6.63847 103 2.5 103 2.5",
    stroke: "#2A8E5C",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_23534",
    x1: 2,
    y1: 5.37109,
    x2: 2,
    y2: 55.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A8E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45BF82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8E5C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUp);
export default __webpack_public_path__ + "static/media/ChartUp.e3500b21980507913807416f29d585bc.svg";
export { ForwardRef as ReactComponent };